
import React, { useMemo } from 'react';

class WalletUtilizationManager {
  constructor(data) {
    this.data = data
    this.walletEnable = data.wallet_enable
    this.totalWalletAmount =  data.total_wallet_amount ?? 0 // dropping soon
    this.totalCompanyEmployeesCount = data.total_company_employees_count ?? 0
    this.repeatSponsoredUserCount = data.repeat_user ?? 0
    this.activeSponsoredEmployeesCount = data.active_user ?? 0
    this.activeEmployeesCount = data.active_employees_count ?? 0
    this.totalEmployeesCount = (data.wallet_utilized_active_user_count + data.wallet_utilized_inactive_user_count) ?? 0
    this.totalEmployeesCountotalWalletUtilization = this.formatAmount(data.total_wallet_utilization) ?? 0

    // not in use, dropping soon

    this.walletUtilizedActiveUserCount = data.wallet_utilized_active_user_count ?? 0
    this.walletUtilizedInactiveUserCount = data.wallet_utilized_inactive_user_count ?? 0
    this.walletUtilizedActiveEmployeeCount = data.wallet_utilized_active_employee_count ?? 0
    this.walletUtilizedInactiveEmployeeCount = data.wallet_utilized_inactive_employee_count ?? 0
    this.walletUtilizedActiveDependentCount = data.wallet_utilized_active_dependent_count ?? 0
    this.walletUtilizedInactiveDependentCount = data.wallet_utilized_inactive_dependent_count ?? 0
    this.walletUtilizedActiveUserAmount = this.formatAmount(data.wallet_utilized_active_user_amount) ?? 0
    this.walletUtilizedInactiveUseramount = this.formatAmount(data.wallet_utilized_inactive_user_amount) ?? 0
    this.walletUtilizedActiveEmployeeAmount = this.formatAmount(data.wallet_utilized_active_employee_amount) ?? 0
    this.walletUtilizedInactiveEmployeeAmount = this.formatAmount(data.wallet_utilized_inactive_employee_amount) ?? 0
    this.walletUtilizedActiveDependentAmount = this.formatAmount(data.wallet_utilized_active_dependent_amount) ?? 0
    this.walletUtilizedInactiveDependentAmount = this.formatAmount(data.wallet_utilized_inactive_dependent_amount) ?? 0
   

    this.activeEmployeeUtilizationPercentage = data.active_employee_utilization_percentage ?? 0
    this.activeEmployeeUtilizationPercentageAmount = this.getUtilizatedPercentageAmount(data.active_employee_utilization_percentage, this.totalCompanyEmployeesCount)
    
    this.averageUtilizePerEmployeegeAmountPercentage = data.average_utilize_per_employee_percentage ?? 0 // dropping soon
    this.averageAmountAddedPerEmployees = data.average_amount_added_per_employees ?? 0 // dropping soon
    this.averageUtilizePerEmployeegeAmount = this.data.average_utilize_per_employee // dropping soon
    this.amountUtilizedPercentage = data.amount_utilized_percentage ?? 0 // dropping soon
    this.amountUtilizedPercentageAmount = this.getUtilizatedPercentageAmount(this.amountUtilizedPercentage, this.totalWalletAmount) // dropping soon
    
    this.totalUtilizedEmployeesCount =  data.total_wallet_user_employee_count ?? 0
    this.barLabelsWallet = this.getMonthOrder(data.month_on_month_transaction);
    this.bardataWallet = this.getBarData(data.month_on_month_transaction)
    this.highestValueNotation = this.getHighestValueNotation(this.bardataWallet)
    this.barBgColorsWallet = this.getBarBgColors(this.bardataWallet)
    this.sankyChartWalletUtilizationData = this.sankyChartWalletUtilizationData()
  }

  // Function to get the bar data in the correct order
  getBarData(monthData) {
    const dynamicOrder = this.getMonthOrder(monthData);

    // Initialize an object with all months in the dynamic order set to 0
    let monthOnMonthTransaction = dynamicOrder.reduce((acc, month) => {
    acc[month] = 0;
    return acc;
  }, {});

  // Populate the object with the actual data
  if (monthData && typeof monthData === 'object') {
    for (let [month, value] of Object.entries(monthData)) {
      if (dynamicOrder.includes(month)) {
        monthOnMonthTransaction[month] = value;
      }
    }
  }
  // Return the values in the order of dynamicOrder
  return dynamicOrder.map(month => monthOnMonthTransaction[month]);
}

  getMonthOrder(monthData) {
    if (monthData === null || monthData === undefined) return [];

    const dataMonths = Object.keys(monthData);
    return dataMonths;
  }



  getUtilizatedPercentageAmount(num, total) {
    if (num === null || num === undefined) return '0';
    
    return   Math.round(total * (num/100))  
  }
  
  getHighestValueNotation(arr){
    const maxValue = Math.max(...arr.map(Number))
    return this.getNumberNotation(maxValue)
  }

  getNumberNotation(value){
    if (value >= 10000000) {
      return 'Cr'; // Crores
    } else if (value >= 100000) {
      return 'L'; // Lakhs
    } else if (value >= 1000) {
      return 'K'; // Thousands
    }
    return '';
  }

  nFormatter(num, digits) {
    if (num === null || num === undefined) return '0';

    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'k' },
      { value: 1e5, symbol: 'L' },
      { value: 1e7, symbol: 'Cr' }
    ];

    const item = lookup.slice().reverse().find(item => num >= item.value);

    if (item) {
      return (num / item.value).toFixed(digits).replace(/\.0+$/, '') + item.symbol;
    }

    return num.toString();
  }

  formatAmount(amount) {
    return this.nFormatter(amount, 1) ?? 0;
  }

  getBarBgColors(bardata){
    // Generate bar background colors
    const maxVal = Math.max(...bardata.map(val => parseFloat(val)));
    return bardata.map((value) => {
      return parseFloat(value) === maxVal ? '#60A5FA' : '#D1D5DB';
    });
  }

  getMaxIndex(arr) {
    let maxInd = 0;
    for (let [ind, ele] of arr.entries()) {
      if (ele > arr[maxInd]) maxInd = ind;
    }
    return maxInd;
  }

  barChartWalletUtilization = () => { }
  sankyChartWalletUtilizationData = () => { 
    
      const point1  = `Total employee - ${this.totalUtilizedEmployeesCount || 0}`
      const amount1 = `(Amount Utilized ${this.totalEmployeesCountotalWalletUtilization || 0})`
      const point2  = `Active employees - ${this.walletUtilizedActiveUserCount || 0}`
      const amount2 = `(Amount Utilized ${this.walletUtilizedActiveUserAmount || 0})`
      const point3  = `Inactive employees - ${this.walletUtilizedInactiveUserCount|| 0}`
      const amount3 = `(Amount Utilized ${this.walletUtilizedInactiveUseramount})`
      const point4  = `For themselves - ${this.walletUtilizedActiveEmployeeCount|| 0}`
      const amount4 = `(Amount Utilized ${this.walletUtilizedActiveEmployeeAmount})`
      const point5  = `For dependents -${this.walletUtilizedActiveDependentCount || 0 }`
      const amount5 = `(Amount Utilized ${this.walletUtilizedActiveDependentAmount || 0})`
      const point6  = `For themselves -${this.walletUtilizedInactiveEmployeeCount || 0}`
      const amount6 = `(Amount Utilized ${this.walletUtilizedInactiveEmployeeAmount || 0})`
      const point7  = `For dependents - ${this.walletUtilizedInactiveDependentCount || 0}`
      const amount7 = `(Amount Utilized ${this.walletUtilizedInactiveDependentAmount||0})`
      const data = {
        nodes: [{ id: point1, amount: amount1 },
                { id: point2, amount: amount2 },
                { id: point3, amount: amount3 },
                { id: point4, amount: amount4 },
                { id: point5, amount: amount5 },
                { id: point6, amount: amount6 },
                { id: point7, amount: amount7 }],
        links: [
          {
            source: point1,
            target: point2,
            value: 75,
          },
          {
            source: point1,
            target: point3,
            value: 40,
          },
          {
            source: point2,
            target: point4,
            value: 49,
          },
          {
            source: point2,
            target: point5,
            value: 27,
          },
          {
            source: point3,
            target: point6,
            value: 23,
          },
          {
            source: point3,
            target: point7,
            value: 17,
          }
        ],
      }

      const colors = ['#1D4ED8', '#14866D', '#E8432C', '#4FAD96', '#60A5FA', '#475569', '#9CA3AF']
      return { data, colors }
  }
}
export default WalletUtilizationManager;
